import React, { Fragment } from 'react';

const EightParticipants = () => {
  return (
    <Fragment>
      <div className="group-participants">
        <div className="participants-panel">
          <div className="participant">
            <div className="participant-avi"></div>
            <p className="participant-name">User Name</p>
          </div>
          <div className="participant">
            <div className="participant-avi"></div>
            <p className="participant-name">User Name</p>
          </div>
          <div className="participant">
            <div className="participant-avi"></div>
            <p className="participant-name">User Name</p>
          </div>
          <div className="participant">
            <div className="participant-avi"></div>
            <p className="participant-name">User Name</p>
          </div>
        </div>
        <div className="participants-panel">
          <div className="participant">
            <div className="participant-avi"></div>
            <p className="participant-name">User Name</p>
          </div>
          <div className="participant">
            <div className="participant-avi"></div>
            <p className="participant-name">User Name</p>
          </div>
          <div className="participant">
            <div className="participant-avi"></div>
            <p className="participant-name">User Name</p>
          </div>
          <div className="participant">
            <div className="participant-avi"></div>
            <p className="participant-name">User Name</p>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default EightParticipants;
